import AdminPanelSettingsRounded from '@mui/icons-material/AdminPanelSettingsRounded';
import GroupsRounded from '@mui/icons-material/GroupsRounded';
import HomeRounded from '@mui/icons-material/HomeRounded';
import RateReviewRounded from '@mui/icons-material/RateReviewRounded';
import { MODULES } from '@/modules/registry';
import type { NavEntry } from '@/modules/types';
import type { SessionValue } from '@/platform/session';

const HOME: NavEntry = {
  to: '/',
  label: 'Início',
  icon: HomeRounded,
  roles: ['admin', 'coordinator', 'teacher', 'student'],
};
const PEOPLE: NavEntry = {
  to: '/people',
  label: 'Pessoas',
  icon: GroupsRounded,
  roles: ['admin', 'coordinator'],
};
/** Question review: for whoever was invited, whatever their role (see ReviewPage). */
const REVIEW: NavEntry = {
  to: '/revisao',
  label: 'Revisão',
  icon: RateReviewRounded,
  roles: ['admin', 'coordinator', 'teacher', 'student', 'reviewer'],
};
const ADMIN: NavEntry = {
  to: '/admin',
  label: 'Administração',
  icon: AdminPanelSettingsRounded,
  roles: ['admin'],
};

/** Main navigation for the signed-in person: core pages + enabled modules, filtered by role. */
export function buildNav(
  session: Pick<SessionValue, 'role' | 'hasModule'> & {
    me?: Pick<SessionValue['me'], 'reviewer'>;
    user?: SessionValue['user'];
  },
): NavEntry[] {
  const moduleEntries = MODULES.filter((m) => session.hasModule(m.key)).flatMap((m) => m.nav);
  const review = session.me?.reviewer && session.hasModule('assessments') ? [REVIEW] : [];
  const user = session.user;
  return [HOME, ...moduleEntries, ...review, PEOPLE, ADMIN].filter(
    (item) => item.roles.includes(session.role) && !(user && item.hiddenFor?.(user)),
  );
}

export function activeNavItem(items: NavEntry[], pathname: string) {
  const match = [...items]
    .sort((a, b) => b.to.length - a.to.length)
    .find((item) => (item.to === '/' ? pathname === '/' : pathname.startsWith(item.to)));
  return match?.to ?? false;
}
